export default __webpack_public_path__ + "static/media/logo2-vinho.8c11a9fa.png";